class Contacte {
    constructor(
        public id = 0,
        public key = 0,
        public nom = "",
        public cognoms = "",
        public telefon = "",
        public telefon2 = "",
        public telefon3 = "",
        public email = "",
        public direccio = "",
        public dni = "",
        public pagador = 0,
        public metalic = 0,
        public IBAN = "",
        public IBANentitat = "",
        public IBANoficina = "",
        public IBANdc = "",
        public IBANnum = "",
        public quota = 0,
        public creacio = "",
        public modificacio = "",
        public autoritzat = 0,
        public parentesc = ""
    ) {
        this.id = id;
        this.key = key;
        this.nom = nom;
        this.cognoms = cognoms;
        this.telefon = telefon;
        this.telefon2 = telefon2;
        this.telefon3 = telefon3;
        this.email = email;
        this.direccio = direccio;
        this.dni = dni;
        this.pagador = pagador;
        this.metalic = metalic;
        this.IBAN = IBAN;
        this.IBANentitat = IBANentitat;
        this.IBANoficina = IBANoficina;
        this.IBANdc = IBANdc;
        this.IBANnum = IBANnum;
        this.quota = quota;
        this.creacio = creacio;
        this.modificacio = modificacio;
        this.autoritzat = autoritzat;
        this.parentesc = parentesc;
    }
}

export default Contacte;